import { createSlice } from '@reduxjs/toolkit'
import { RootState } from "../../types";

const initialState: RootState['country'] = {
  countryList: [],
  usaRegions: [],
  indiaRegions: [],
  australiaRegions: []
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setCountryList(state, action) {
      state.countryList = action.payload;
    },
    setUsaRegions(state, action) {
      state.usaRegions = action.payload;
    },
    setIndiaRegions(state, action) {
      state.indiaRegions = action.payload;
    },
    setAustraliaRegions(state, action) {
      state.australiaRegions = action.payload;
    }
  }
})

export const { setCountryList, setIndiaRegions, setAustraliaRegions, setUsaRegions } = countrySlice.actions;

export default countrySlice.reducer;